import React, { useState, useEffect } from 'react';
import Pagination from 'components/common/pagination';
import Table from 'components/Form/Table';
import EmptyState from 'components/EmptyState';
import Fetching from 'components/Fetching';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import styles from '../terminal.module.scss';
import { RightChevron } from '../../../assets/svgs';
import Badge from '../../../components/Badge';

const TerminalLog = (props) => {
  const history = useHistory();

  const { inProgress, page, meta, data, handleTerminalPagination } = props;

  const statusTextColorMapping = {
    NEW: { color: 'muted', text: 'NEW' },
    ACTIVATED: { color: 'green', text: 'ACTIVATED' },
    ASSIGNED: { color: 'green', text: 'ASSIGNED' },
    RECEIVED: { color: 'yellow', text: 'RECEIVED' },
    UNASSIGNED: { color: 'yellow', text: 'UNASSIGNED' },
    DECOMMISSIONED: { color: 'red', text: 'DECOMMISSIONED' },
  };

  return (
    <>
      {inProgress ? (
        <div className={styles.terminalListEmpty}>
          <Fetching />
        </div>
      ) : data && data.length === 0 ? (
        <div className={styles.terminalListEmpty}>
          <EmptyState text="Request and activate your terminal to see the details here." />
        </div>
      ) : (
        <>
          <div
            className={styles.terminalListContent}
            data-testid="terminal-log-table"
          >
            <div className={styles.terminalListContentBody}>
              <Table>
                <Table.Thead>
                  <Table.Tr>
                    <Table.Th>TERMINAL ID</Table.Th>
                    <Table.Th>SERIAL NUMBER</Table.Th>
                    <Table.Th>DATE ASSIGNED</Table.Th>
                    <Table.Th>STATUS</Table.Th>
                    <Table.Th />
                  </Table.Tr>
                </Table.Thead>
                <Table.TBody>
                  {data &&
                    data.map((item) => (
                      <Table.Tr
                        key={item.id}
                        onClick={() => {
                          history.push({
                            pathname: `/terminal/${item.id}`,
                            state: item,
                          });
                        }}
                      >
                        <Table.Td>{`${item.terminalId || '-'}`}</Table.Td>
                        <Table.Td>{`${item.serialNumber || '-'}`}</Table.Td>
                        <Table.Td>
                          {item.createdAt &&
                            moment(item.createdAt).format(
                              'DD MMMM YYYY hh:mm A',
                            )}
                        </Table.Td>
                        <Table.Td>
                          <Badge
                            color={statusTextColorMapping[item.status]?.color}
                          >
                            {statusTextColorMapping[item.status]?.text}
                          </Badge>
                        </Table.Td>
                        <Table.Td>
                          <RightChevron />
                        </Table.Td>
                      </Table.Tr>
                    ))}
                </Table.TBody>
              </Table>
            </div>
          </div>
          <div className={styles.terminalPagination} data-testid="pagination">
            <p>
              Showing{' '}
              {meta.page === 0 ? data.length : data.length * (meta.page + 1)}{' '}
              items out of {Math.ceil(meta.total / meta.limit)}
              {Math.ceil(meta.total / meta.limit) > 1 ? ' pages' : ' page'}{' '}
              found
            </p>
            <div>
              <Pagination
                currentPage={page}
                handlePageClick={handleTerminalPagination}
                totalItems={Math.ceil(meta.total / meta.limit)}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TerminalLog;
